// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__aMj_v","title":"Images45_title__3o_cb","images":"Images45_images__3uYvO"};